(function () {
  var locale = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
  var phraseWordThreshold = 4;
  var catalogTerms = [
    'fibre',
    'fiber',
    'blaireau',
    'blaireaux',
    'rasage',
    'rasoir',
    'savon',
    'lame',
    'lames',
    'parfum',
    'brosse',
    'brosses',
    'voyage',
    'palladium',
    'preshave',
    'alun',
    'joris'
  ];
  var stopWords = {
    de: 1, du: 1, des: 1, la: 1, le: 1, les: 1, un: 1, une: 1, et: 1, ou: 1,
    a: 1, au: 1, aux: 1, pour: 1, par: 1, sur: 1, avec: 1, sans: 1, son: 1,
    sa: 1, ses: 1, ce: 1, cet: 1, cette: 1, mon: 1, ma: 1, mes: 1, en: 1,
    comment: 1, pourquoi: 1, quand: 1, quel: 1, quelle: 1, prendre: 1,
    of: 1, the: 1, and: 1, for: 1, with: 1, how: 1, why: 1, to: 1, my: 1, or: 1
  };
  var topicMarkers = {
    de: 1, du: 1, des: 1, la: 1, le: 1, les: 1, un: 1, une: 1, et: 1,
    pour: 1, par: 1, avec: 1, sans: 1, son: 1, sa: 1, ses: 1, comment: 1,
    pourquoi: 1, quand: 1, quel: 1, quelle: 1, prendre: 1, of: 1, the: 1,
    and: 1, for: 1, with: 1, how: 1, why: 1, to: 1
  };
  var pairs = [
    {
      pattern: /high\s*mountain\s*white(?:\s*fibr[ea])?/i,
      fr: 'Blanc Haute Montagne'
    },
    {
      pattern: /russian\s*grey|russian\s*gray/i,
      fr: 'Gris de Russie'
    },
    {
      pattern: /european\s*grey|european\s*gray/i,
      fr: 'Gris Européen'
    }
  ];

  function damerau(a, b) {
    var m = a.length;
    var n = b.length;
    if (Math.abs(m - n) > 2) return 99;
    var dp = [];
    var i;
    var j;
    for (i = 0; i <= m; i++) {
      dp[i] = [i];
    }
    for (j = 0; j <= n; j++) dp[0][j] = j;
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          dp[i][j] = Math.min(dp[i][j], dp[i - 2][j - 2] + 1);
        }
      }
    }
    return dp[m][n];
  }

  function maxDistance(word) {
    return word.length >= 6 ? 2 : 1;
  }

  function closestTerm(word) {
    var lower = word.toLowerCase();
    if (lower.length < 4 || stopWords[lower]) return word;
    var best = null;
    var bestDistance = 99;
    for (var i = 0; i < catalogTerms.length; i++) {
      var term = catalogTerms[i];
      if (term === lower) return word;
      var distance = damerau(lower, term);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = term;
      }
    }
    if (!best || bestDistance > maxDistance(lower) || bestDistance === 0) return word;
    if (best === 'fiber' && locale === 'fr') return 'fibre';
    if (best === 'fibre' && locale === 'en') return 'fiber';
    return word[0] === word[0].toUpperCase()
      ? best.charAt(0).toUpperCase() + best.slice(1)
      : best;
  }

  function correctTypos(query) {
    if (!query || typeof query !== 'string') return query;
    return query.replace(/[A-Za-zÀ-ÿ]{4,}/g, closestTerm);
  }

  function expandQuery(query) {
    if (locale !== 'fr') return query;
    if (!query || typeof query !== 'string') return query;
    var trimmed = query.trim();
    if (!trimmed || /\bOR\b/i.test(trimmed)) return trimmed;

    var additions = [];
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      if (!pair.pattern.test(trimmed)) continue;
      pair.pattern.lastIndex = 0;
      if (trimmed.toLowerCase().indexOf(pair.fr.toLowerCase()) === -1) {
        additions.push(pair.fr);
      }
    }

    if (!additions.length) return trimmed;
    return trimmed + ' OR ' + additions.join(' OR ');
  }

  function wordsOf(query) {
    return String(query || '')
      .replace(/"/g, '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function isTopicQuery(query) {
    var words = wordsOf(query);
    if (words.length < phraseWordThreshold) return false;
    var markers = 0;
    for (var i = 0; i < words.length; i++) {
      if (topicMarkers[words[i].toLowerCase()]) markers += 1;
    }
    return markers >= 2;
  }

  function phraseQuoteQuery(query) {
    if (!query || typeof query !== 'string') return query;
    var trimmed = query.trim();
    if (!trimmed) return trimmed;
    if (/^".*"$/.test(trimmed)) return trimmed;
    if (/\b(?:OR|AND|NOT)\b/i.test(trimmed)) return trimmed;
    if (/[*()]/.test(trimmed)) return trimmed;
    if (!isTopicQuery(trimmed)) return trimmed;
    return '"' + trimmed.replace(/"/g, '') + '"';
  }

  function normalizeQuery(query, forSuggest) {
    var next = correctTypos(query);
    next = expandQuery(next);
    if (!forSuggest) next = phraseQuoteQuery(next);
    return next;
  }

  function resourceTypesFor(query, forSuggest) {
    if (!forSuggest) return null;
    if (isTopicQuery(query)) return 'query,article,page';
    return 'query,product,collection,page,article';
  }

  function isSearchPath(path) {
    return (path || '').indexOf('/search') !== -1;
  }

  function isSuggestPath(path) {
    return (path || '').indexOf('/search/suggest') !== -1;
  }

  function rewriteSearchUrl(urlString) {
    try {
      var url = new URL(urlString, window.location.origin);
      var path = url.pathname || '';
      if (!isSearchPath(path)) return urlString;

      var changed = false;
      var forSuggest = isSuggestPath(path);
      var q = url.searchParams.get('q');
      if (q) {
        var normalized = normalizeQuery(q, forSuggest);
        if (normalized !== q) {
          url.searchParams.set('q', normalized);
          q = normalized;
          changed = true;
        }
      }

      var types = resourceTypesFor(q, forSuggest);
      if (types && url.searchParams.get('resources[type]') !== types) {
        url.searchParams.set('resources[type]', types);
        changed = true;
      }

      return changed ? url.toString() : urlString;
    } catch (e) {
      return urlString;
    }
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    if (typeof input === 'string') {
      input = rewriteSearchUrl(input);
    } else if (input && typeof input.url === 'string') {
      var next = rewriteSearchUrl(input.url);
      if (next !== input.url) {
        input = new Request(next, input);
      }
    }
    return originalFetch.call(this, input, init);
  };

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1 && form.id !== 'predictive-search-form') return;

      var input = form.querySelector('[name="q"]');
      if (!input) return;

      var normalized = normalizeQuery(input.value, false);
      if (normalized === input.value.trim()) return;

      event.preventDefault();
      var url = new URL(form.action || (window.Shopify.routes.root + 'search'), window.location.origin);
      url.searchParams.set('q', normalized);
      var typeInput = form.querySelector('[name="type"]');
      if (typeInput && typeInput.value) url.searchParams.set('type', typeInput.value);
      window.location.assign(url.toString());
    },
    true
  );
})();
